import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import ServiceSide from "./ServiceSide";
import { NavLink } from "react-router-dom";

function Services() {
  return (
    <>
      <SEO
        title="Digital Marketing Services | SEO, PPC & Social Media – Moironix"
        description="Grow Your Business with Moironix! Expert Seo, PPC, Social Media, and Content Marketing Services to Boost Traffic, Leads, and Conversions"
        keywords="Digital Marketing, Local Seo Services, Social Media Marketing, Content Marketing Strategy, Email Marketing Automation Services, Pay Per Click Management, Conversion Rate Optimization Services, Digital Marketing Agency, Seo Services, Social Media Marketing Services, Content Marketing Services, PPC Management, Digital Marketing Services"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Digital Marketing</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">Digital Marketing</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="site-main">
          <div className="prt-row sidebar prt-sidebar-left clearfix">
            <div className="container">
              <div className="row">
                <div className="widget-area sidebar-left prtcol-bgcolor-yes prt-bg prt-left-span bg-base-grey">
                  <ServiceSide />
                </div>
                <div className="col-lg-8 content-area">
                  <div className="prt-service-single-content-area">
                    <div className="prt_fatured_image-wrapper mb-40 res-575-mb-20">
                      <img
                        width={859}
                        height={440}
                        className="img-fluid"
                        src="images/d4.jpeg"
                        alt="services-1"
                      />
                    </div>
                    <div className="prt-service-description">
                      <h3>Digital Marketing</h3>
                      <p>
                        In today’s competitive digital landscape, having a
                        robust online presence is crucial for the growth of any
                        business. Moironix Soft Solutions offers comprehensive
                        digital marketing services designed to elevate your
                        brand and connect you with your target audience
                        effectively. Our tailored strategies ensure that you
                        stand out in the crowded digital space, driving more
                        traffic, leads, and conversions for your business.
                      </p>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <ul className="service-detail-list">
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Search Engine Optimization (SEO)
                              </div>
                            </li>
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Pay-Per-Click Advertising (PPC)
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Social Media Marketing
                                </div>
                              </li>
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Content Marketing
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Email Marketing
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <div>
                              <ul className="service-detail-list">
                                <li className="service-detail-list-item">
                                  <div className="service-detail-list-text">
                                    Analytics and Reporting
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <Footer />
    </>
  );
}

export default Services;
